import { render, staticRenderFns } from "./add-or-edit-hhk.vue?vue&type=template&id=3f104caa&scoped=true&"
import script from "./add-or-edit-hhk.vue?vue&type=script&lang=js&"
export * from "./add-or-edit-hhk.vue?vue&type=script&lang=js&"
import style0 from "./add-or-edit-hhk.vue?vue&type=style&index=0&id=3f104caa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f104caa",
  null
  
)

export default component.exports